<template>
  <div id="pagination" class="fixed left-1/2 max-w-125 w-full flex lt-sm:(top-0 px-4) sm:bottom-8 -translate-x-1/2"></div>
</template>

<script setup lang="ts"></script>

<style>
@keyframes fill {
  from {
    width: 0;
  }

  to {
    width: 100%;
  }
}

.swiper-pagination-bullet {
  position: relative;
  flex: 1;
  height: 25px;
  padding: 10px 0;
  cursor: pointer;
}

.swiper-pagination-bullet:not(:last-of-type) {
  margin-right: 5px;
}

.swiper-pagination-bullet::after,
.swiper-pagination-bullet::before {
  content: "";
  position: absolute;
  top: 10px;
  right: 0;
  left: 0;
  height: 5px;
  border-radius: 3px;
}

.swiper-pagination-bullet::before {
  z-index: 1;
  background-color: #fff;
  opacity: 0.2;
  transition: 0.3s;
}

.swiper-pagination-bullet::after {
  width: 100%;
  z-index: 2;
  background-color: #fff;
}

.swiper-pagination-bullet.swiper-pagination-bullet-active::after {
  animation: fill linear 15s;
}

.swiper-pagination-bullet.swiper-pagination-bullet-active ~ .swiper-pagination-bullet::after {
  width: 0;
}

@media (max-width: 414px) {
  .swiper-pagination-bullet {
    height: 35px;
    padding: 15px 0;
  }

  .swiper-pagination-bullet::after,
  .swiper-pagination-bullet::before {
    top: 15px;
  }
}
</style>
